export function stringIncludes(source, target) {
    var _a, _b;
    return (_b = (_a = (source || '')).toLowerCase) === null || _b === void 0 ? void 0 : _b.call(_a).includes((target || '').toLowerCase() || '');
}
